// @flow

import "babel-polyfill";
import * as React from "react";
import { render } from "react-snapshot";
import { BrowserRouter as Router, Route } from "react-router-dom";

import { ApolloClient, InMemoryCache } from "apollo-client-preset";
import { ApolloProvider } from "react-apollo";
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";

import App from "./components/App/App";
import "./index.css";

const environment = process.env.NODE_ENV;

var loggedEnvironment = false;
const apiUri =
  environment === "production"
    ? "https://api.graph.cool/simple/v1/cjc6oyx3f0b700128ypy2gntc"
    : "https://api.graph.cool/simple/v1/cje0lq3ae43580150pyvgtmxq";

const httpLink = createHttpLink({
  uri: apiUri
});

const middlewareLink = setContext(() => {
  const token = localStorage.getItem("graphcoolToken");
  if (!loggedEnvironment) {
    console.log("Environment: ", environment);
    loggedEnvironment = true;
  }
  return {
    headers: {
      authorization: token ? `Bearer ${token}` : null
    }
  };
});

const client = new ApolloClient({
  link: middlewareLink.concat(httpLink),
  cache: new InMemoryCache()
});

render(
  <ApolloProvider client={client}>
    <Router>
      <div>
        <Route path="/" component={App} />
      </div>
    </Router>
  </ApolloProvider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js